module.exports = __webpack_public_path__ + "ed78c91eee5a4d3f1c8394a528e1b80a.MP3";